// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea[data-v-f35dbd85]{width:20em}`, "",{"version":3,"sources":["webpack://./src/components/ReferralProgram/RouteComponents/ReferralProgram/styles.scoped.scss"],"names":[],"mappings":"AAAA,0BAA0B,UAAU","sourcesContent":["textarea[data-v-f35dbd85]{width:20em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
